module.exports = __webpack_public_path__ + "img/winners4.32cbe1fb.svg";